class SpotlightMobileCarousel extends HTMLElement {
    constructor() {
      super();
      this.carousel = null; 
      this.isMobile = window.innerWidth <= 1068;
    }
  
    connectedCallback() {
      setTimeout(() => this.initCarousel(), 0);
      window.addEventListener('resize', this.onResize.bind(this));
    }
  
    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize.bind(this));
      if (this.carousel) {
        this.carousel.destroy();
      }
    }
  
  
    initCarousel() {
      if (this.isMobile && !this.carousel) {
        const childLength = this.querySelectorAll('.spotlight-banner-inner-mobile .slide-item')?.length || 0
        if(childLength > 1) {
        //console.log(this.querySelector('.spotlight-banner-inner-mobile .slider'))
          this.carousel = new Flickity(this.querySelector('.spotlight-banner-inner-mobile .slider'), {
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            prevNextButtons: false,
          });
        }
      } else if (!this.isMobile && this.carousel) {
        this.carousel.destroy();
        this.carousel = null;
      }
    }
  
    onResize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768;

      if (this.isMobile !== wasMobile) {
        this.initCarousel();
      }
    }
  }
  
  customElements.define('spotlight-mobile-carousel', SpotlightMobileCarousel);